import clsx from 'clsx'
import React, {FC} from 'react'
import {HeaderLanguage, HeaderUserMenu} from '../../../partials'
import {HeaderLocationsMenu} from '../../../partials/layout/header-menus/HeaderLocationsMenu'
import {KTSVG} from '../../../helpers'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'

const Topbar: FC = () => {
  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* begin::Language */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        {/* begin::Toggle */}
        <div
          className={clsx(
            'cursor-pointer symbol btn btn-icon btn-active-light-primary btn-custom',
            toolbarUserAvatarHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG path='/media/icons/bootstrap/header/globe2.svg' className='svg-icon-2' />
        </div>
        <HeaderLanguage />
        {/* end::Toggle */}
      </div>
      {/* end::language */}

      {/* begin::User */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        {/* begin::Toggle */}
        <div
          className={clsx(
            'cursor-pointer symbol btn btn-icon btn-active-light-primary btn-custom',
            toolbarUserAvatarHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG path='/media/icons/bootstrap/header/person-fill.svg' className='svg-icon-1' />
        </div>
        <HeaderUserMenu />
        {/* end::Toggle */}
      </div>
      {/* end::User */}
    </div>
  )
}

export {Topbar}
